import React from 'react';
import PropTypes from 'prop-types';
import MainNavAboutUsLinkComponent from './MainNavAboutUsLink.styles';

import Link from '../../../shared/Link/Link';
import { mediaApi } from '@sitecore-jss/sitecore-jss-react';

const MainNavAboutUsLink = ({ text, src, alt, isHeading = true, ...props }) => {
  const imageUrl = mediaApi.updateImageUrl(src, { mw: 800, mh: 800 });
  return (
    <MainNavAboutUsLinkComponent {...props}>
      <Link path={props.path}>
        <h2 role={isHeading ? undefined : 'presentation'}>{text}</h2>
        <div className="image">
          <img src={imageUrl} alt={alt ?? `view ${text} page`} />
          <div>View</div>
        </div>
      </Link>
    </MainNavAboutUsLinkComponent>
  );
};

MainNavAboutUsLink.propTypes = {
  text: PropTypes.string,
  src: PropTypes.string,
  alt: PropTypes.string,
  isHeading: PropTypes.bool,
};

export default MainNavAboutUsLink;